import React, { useState } from 'react';
import { apiService } from '../../services/api';
import { useMutation } from '../../hooks/useApi';
import logger from '../../utils/logger';
import { useSettings } from '../../context/SettingsContext';
import { Eye, FileDown } from 'lucide-react';

function RaportBottom10() {
  const { getCurrencyCode } = useSettings();
  const currencyCode = getCurrencyCode();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [data, setData] = useState([]);
  const [error, setError] = useState('');

  const { mutate: fetchRaport, loading: loadingRaport } = useMutation(
    async ({ from, to }) => {
      return await apiService.get('/raport-bottom10', { params: { from, to } });
    },
    {
      onSuccess: (data) => {
        setData(Array.isArray(data) ? data : (data?.data || []));
        setError('');
      },
      onError: () => {
        setError('Nuk mund te merret raporti.');
      },
      showNotifications: false
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    fetchRaport({ from, to });
  };

  const handleExportPdf = async () => {
    if (!from || !to) {
      setError('Zgjidhni datat per PDF.');
      return;
    }
    try {
      const response = await apiService.get('/raport-bottom10/pdf', {
        params: { from, to },
        responseType: 'blob'
      });
      const file = new Blob([response], { type: 'application/pdf' });
      window.open(URL.createObjectURL(file));
    } catch (err) {
      logger.error('PDF export error:', err);
      setError('Deshtoi shkarkimi i PDF-it.');
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Raport Bottom 10 Produkte</h2>

      <form onSubmit={handleSubmit} className="card-premium p-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="form-label">Nga data</label>
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="input-premium" required />
        </div>
        <div>
          <label className="form-label">Deri me</label>
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="input-premium" required />
        </div>
        <button type="submit" className="btn-premium mt-auto flex items-center justify-center gap-2">
          <Eye size={18} /> Shfaq
        </button>
      </form>

      {error && <p className="p-3 rounded-lg bg-red-100 text-red-700 dark:bg-red-900/20 dark:text-red-300 font-medium">{error}</p>}

      {data.length > 0 && (
        <div className="space-y-4">
          <button onClick={handleExportPdf} className="btn-premium flex items-center gap-2">
            <FileDown size={18} /> Shkarko PDF
          </button>
          <div className="card-premium overflow-x-auto p-0">
            <table className="table-premium">
              <thead>
                <tr>
                  <th>Produkti</th>
                  <th className="text-right">Sasia</th>
                  <th className="text-right">Totali</th>
                </tr>
              </thead>
              <tbody>
                {data.map((r, i) => (
                  <tr key={i}>
                    <td className="font-medium">{r.emri}</td>
                    <td className="text-right font-semibold">{r.sasia}</td>
                    <td className="text-right font-semibold text-primary-600 dark:text-primary-400">{Number(r.totali).toFixed(2)} {currencyCode}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default RaportBottom10;
